<p class="spacing--none ag-cell-fund-name">
  <eds-link-item
    class="ag-cell-frk--link"
    [title]="fundName"
    [href]="fundLink"
    edsSpacing="'md'"
  ></eds-link-item>
</p>
